import { hasPermission } from "../../Config/permissions";

export const hasDpaMetadata = (row) =>
  [row?.DPAFileName, row?.DPAFileUrl, row?.DPAAzureBlobName].some(
    (value) => value != null && String(value).trim() !== "",
  );

export const canAttachDpa = ({ user, isReady, readOnly, row, account }) =>
  isReady === true &&
  !readOnly &&
  ["Admin", "ASD", "Authorizer", "Viewer"].includes(user?.Type) &&
  hasPermission(user, "manage_accounts.edit") &&
  account?.IsActive !== false &&
  account?.IsChildAccount !== true &&
  row?.IsActive !== false &&
  row?.IsApproved === true &&
  !hasDpaMetadata(row) &&
  Number.isSafeInteger(row?.AccountID) &&
  row.AccountID > 0 &&
  Number.isSafeInteger(row?.ID) &&
  row.ID > 0 &&
  Number(account?.ID) === row.AccountID;
